export const NEW_EMAIL_SEARCH_PARAM_KEY = "new-email";
